import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/TaskTable";
import TaskDrawer from "../components/TaskDrawer";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { fmtDate } from "../lib/ui";
import { useData } from "../lib/DataContext";
import { Clock } from "lucide-react";

export default function FollowUps() {
  const [view, setView] = useState("today");
  const [items, setItems] = useState([]);
  const [openId, setOpenId] = useState(null);
  const { userName } = useData();
  const load = () => api.get("/followups", { params: { view } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [view]);

  return (
    <div className="p-6">
      <PageHeader title="Follow-Ups" subtitle="Scheduled follow-up actions" />
      <Tabs value={view} onValueChange={setView} className="mb-4">
        <TabsList>
          {[["today","Today"],["tomorrow","Tomorrow"],["missed","Missed"],["upcoming","Upcoming"]].map(([k,l]) => (
            <TabsTrigger key={k} value={k} data-testid={`followup-tab-${k}`}>{l}</TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <div className="space-y-2">
        {items.length === 0 && <div className="text-center py-12 text-slate-400 text-sm">No follow-ups {view}.</div>}
        {items.map((f) => (
          <button key={f.id} onClick={() => f.task && setOpenId(f.task.id)} className="w-full text-left bg-white border rounded-lg p-4 hover:bg-slate-50 flex items-center gap-3">
            <div className={`h-9 w-9 rounded-lg flex items-center justify-center ${view === "missed" ? "bg-red-100 text-red-600" : "bg-amber-100 text-amber-600"}`}><Clock size={16} /></div>
            <div className="flex-1">
              <div className="font-mono text-[10px] text-slate-400">{f.task?.human_id}</div>
              <div className="font-medium text-slate-800">{f.task?.title || "—"}</div>
              {f.note && <div className="text-xs text-slate-500">{f.note}</div>}
            </div>
            <div className="text-right text-xs text-slate-500">
              <div>{fmtDate(f.followup_date)} {f.followup_time}</div>
              <div>{userName(f.owner_id)}</div>
            </div>
          </button>
        ))}
      </div>
      {openId && <TaskDrawer taskId={openId} onClose={() => setOpenId(null)} onChanged={load} />}
    </div>
  );
}
